<h2 class="mb-2xl font-bold text-neutral-900 text-base">
  {{
    assignItemsModalTitle() ||
      (itemType() === 'User'
        ? ('assign_items_modal_assign_users_title' | transloco)
        : ('assign_items_modal_assign_groups_title' | transloco))
  }}
</h2>

<div class="grid grid-cols-12 items-end gap-2xl">
  <div class="col-span-6">
    <h6 class="text-xs text-neutral-900 font-semibold">
      {{
        itemType() === 'User'
          ? ('assign_items_modal_find_users_label' | transloco)
          : ('assign_items_modal_find_groups_label' | transloco)
      }}
    </h6>

    <div class="search-input relative flex gap-md items-center py-sm mb-2xl">
      <label
        class="flex items-center w-full border border-neutral-300 rounded-md text-sm p-md">
        <input
          type="text"
          [id]="'search'"
          [placeholder]="'search_by_name_placeholder' | transloco"
          [style.cursor]="
            !groupUsersCards().length && !isSearching() ? 'not-allowed' : ''
          "
          [disabled]="!groupUsersCards().length && !isSearching()"
          #search
          class="bg-transparent text-sm w-full pe-2xl placeholder:text-sm placeholder:text-neutral-500" />

        <div
          class="icon absolute end-3 inset-y-3 cursor-pointer flex items-center">
          <lib-search-icon [iconClass]="'size-5 text-neutral-500'" />
        </div>
      </label>
    </div>

    <div class="pe-md overflow-auto custom-height" (scroll)="onScroll($event)">
      <div class="py-md text-neutral-900 text-xs font-medium">
        {{ 'assign_items_modal_results_section_title' | transloco }}
      </div>
      @if (currentPage() === 1) {
        @if (!isLoading()) {
          <lib-assign-group-user-card
            [cards]="groupUsersCards()"
            (selectCard)="onSelectGroupUser($event)"
            [itemType]="itemType()"
            [section]="'results'" />
        } @else {
          <div class="flex flex-col justify-center items-center">
            <lib-loader />
          </div>
        }
      } @else {
        <lib-assign-group-user-card
          [cards]="groupUsersCards()"
          (selectCard)="onSelectGroupUser($event)"
          [itemType]="itemType()"
          [section]="'results'" />

        @if (isLoading()) {
          <div class="flex flex-col justify-center items-center mt-2xl">
            <lib-loader />
          </div>
        }
      }
    </div>
  </div>

  <div class="col-span-6">
    <div class="pe-md overflow-auto custom-height">
      <div class="py-md text-neutral-900 text-xs font-medium">
        {{ 'assign_items_modal_selected_section_title' | transloco }}
      </div>
      <lib-assign-group-user-card
        [cards]="selectedGroupUsersCards()"
        (removeCard)="removeGroupUser($event)"
        [itemType]="itemType()"
        [section]="'select'" />
    </div>
  </div>
</div>

<footer class="flex justify-end items-end gap-lg mt-2xl">
  <button
    id="assign_items_modal_results_button"
    class="px-lg py-sm rounded-md text-neutral-700 bg-white text-base font-medium cursor-pointer border border-neutral-300"
    (click)="onCancel()">
    {{ 'assign_items_modal_results_button' | transloco }}
  </button>

  <button
    id="assign_items_modal_selected_button"
    class="px-lg py-sm rounded-md text-white bg-primary-500 text-base font-medium cursor-pointer"
    [class.opacity-30]="!selectedGroupUsersCards().length || isSubmitLoading()"
    [disabled]="!selectedGroupUsersCards().length || isSubmitLoading()"
    (click)="onSubmitAssignedGroupUsers()">
    {{ 'assign_items_modal_selected_button' | transloco }}
  </button>
</footer>
